<template>
    <div>
        <div class="card">
            <InnerLoading :is-loading="isLoading"></InnerLoading>
            <div class="card-header">
                <i class="fa fa-list"></i>
                {{title}}
            </div>
            <div class="card-body">
                <div class="row">
                    <div
                        class="col-md-6 offset-2"
                        :class="{'dropdown-has-error':$v.select.id.$error}"
                    >
                        <label>{{title}}*</label>
                        <select-api v-model="select.id" :endpoint="urlSelect" :opt-text="optText"></select-api>
                    </div>
                    <div class="col-md-2">
                        <button
                            type="button"
                            @click="save"
                            class="btn btn-primary"
                            style="margin-top: 30px;"
                        >Adicionar</button>
                    </div>
                </div>

                <div class="row mt-10" style="margin-top: 10px;">
                    <div class="col-md-8 offset-2">
                        <table class="table table-bordered table-striped table-md">
                            <thead>
                                <th v-if="draggable == true"></th>
                                <th>{{ title }}</th>
                                <th>Ações</th>
                            </thead>
                            <draggable v-if="draggable == true"
                              v-model="list"
                              :element="'tbody'"
                              @start="drag=true"
                              @end="drag=false">
                               <tr v-for="item in list" :key="item.id">
                                   <td style="width: 10px;"><i class="fa fa-align-justify"></i></td>
                                   <!-- <td>{{element.prioridade}} - {{element.nome}}</td> -->
                                   <td
                                       :data-label="title"
                                   >{{ item[paramLabel] ? item[paramLabel] : item[paramName].nome }}</td>
                                   <td>
                                       <button
                                           class="btn btn-danger btn-sm"
                                           type="button"
                                           @click="remove(item.id)"
                                       >
                                           <i class="far fa-trash-alt"></i>
                                       </button>
                                   </td>
                               </tr>
                            </draggable>
                            <tbody v-if="draggable == false">
                                <tr v-for="item in list">
                                    <td
                                        :data-label="title"
                                    >{{ item[paramLabel] ? item[paramLabel] : item[paramName].nome }}</td>
                                    <td>
                                        <button
                                            class="btn btn-danger btn-sm"
                                            type="button"
                                            @click="remove(item.id)"
                                        >
                                            <i class="far fa-trash-alt"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SelectApi from "./Input/SelectApi";
import InnerLoading from "./InnerLoading";
import { required } from "vuelidate/lib/validators";
import draggable from 'vuedraggable'

export default {
    components: { InnerLoading, SelectApi, draggable },
    props: [
        "title",
        "urlSelect",
        "optText",
        "modelName",
        "modelId",
        "paramName",
        "paramLabel",
        "objectList",
        "draggable",
        "paramSort"
    ],
    data() {
        return {
            isLoading: true,
            list: [],
            select: {
                id: null
            }
        };
    },
    validations() {
        let vm = this;

        return {
            select: {
                id: {
                    required
                }
            }
        };
    },
    methods: {
        async onEnd(evt) {
          const oldIndex = evt.oldIndex;
          const newIndex = evt.newIndex;

          let dragged = this.list[newIndex];
          let related = this.list[oldIndex];

          dragged[this.paramSort] = newIndex;
          related[this.paramSort] = oldIndex;

          this.$loading.show(true);

          Promise.all([
              await axios.put(`/${this.modelName}/ordenar`, dragged),
              await axios.put(`/${this.modelName}/ordenar`, related)
          ]).then(response => {
              this.$loading.show(false);
              console.log(response);
          });
        },

        async remove(id) {
            this.isLoading = true;
            if (id) {
                const result = await axios.delete(`/${this.modelName}/${id}`);
            }
            this.list = this.list.filter(i => i.id != id);
            this.isLoading = false;
        },

        async save() {
            if (!this.select.id) {
                this.$notify.warning(
                    "Atenção!",
                    `${this.title} é obrigatório.`
                );
            } else {
                const vm = this;
                this.isLoading = true;
                let existed = _.find(this.list, item => {
                    if (item["id"] == vm.select.id) {
                        return item;
                    }
                });
                if (existed == undefined) {
                    const info = {
                        id_info: this.select.id,
                        id_model: this.modelId
                    };
                    const result = await axios.post(`/${this.modelName}`, info);
                    const infos = await axios.get(`/${this.paramName}/${this.modelId}`);
                    this.list = infos.data.data[this.objectList];

                    this.select.id = null;
                    this.$forceUpdate();
                } else {
                    this.$notify.warning(
                        "Atenção!",
                        `Esse(a) ${this.title} já foi adicionado(a).`
                    );
                }

                this.isLoading = false;
            }
        }
    },
    async mounted() {
        this.list = [];
        const infos = await axios.get(`/${this.paramName}/${this.modelId}`);
        this.list = infos.data.data[this.objectList];

        if (this.draggable == true) {
          this.list = _.sortBy(this.list, [this.paramSort])
        }

        this.isLoading = false;
    }
};
</script>



// WEBPACK FOOTER //
// DWSelectAdd.vue?23b91262